import img1 from '../../assets/team/YashMishra.png'
import img2 from '../../assets/team/Kamakshi.png'
import img3 from '../../assets/team/ShashankShekharYadav.jpg'
import img4 from '../../assets/team/ShivangSinghRawat.jpg'
import img5 from '../../assets/team/SaurabhSrivastav.jpg'
import img6 from '../../assets/team/ShiwatviManorama.jpg'
import img7 from '../../assets/team/ShoaibAhmed.png'
import img8 from '../../assets/team/Anshika.png'
import img11 from '../../assets/team/DivyanshuGupta.png'
import YashSarin from '../../assets/team/YashSarin.png'
import RudranshJain from '../../assets/team/RudranshJain.jpg'
import ShubhanshMahawar from '../../assets/team/ShubhanshMahawar.jpg'
import BhaskarDev from '../../assets/team/BhashkarDev.png'
import ShreyashPandey from '../../assets/team/ShreyashPandey.jpg'
import AdityaKumar from '../../assets/team/alumini/AdityaKumar.jpeg'
import Neelansh from '../../assets/team/Neelansh.png'
import NamanKumar from '../../assets/team/alumini/NamanKumar.jpeg'
import AbhayBansal from '../../assets/team/AbhayBansal.jpeg'
import AnuroopaGoswami from '../../assets/team/alumini/AnuroopaGoswami.jpg'
import PrabhanshTripathi from '../../assets/team/alumini/PrabhanshTripathi.jpg'
import SarveshGautam from '../../assets/team/alumini/SarveshGautam.jpg'



export const Cordinators=[ 
    {
    name:'Mr. Yash Mishra',	
    position: 'President',
    mail: 'mailto:yash.20b0131154@abes.ac.in',
    linkedIn: 'https://in.linkedin.com/in/yash-mishra-b2290220a',
    instagram:'https://instagram.com/yashprime02', 
    image: img1,	
},
{
    name:'Ms. Kamakshi Agarwal',
    position: 'Vice President',
    mail: 'mailto:Kamakshi.20b1541032@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/-kamakshi-agarwal/'	,
    instagram:'https://instagram.com/kamakshiii_20',
    image:img2,
},
{           		
    name:'Mr. Yash Sarin',
    position:'Treasurer',
    mail:'mailto:Yash.20B0311044@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/yash-sarin-84185b221',
    image: YashSarin,
},
{
    name:'Mr. Neelansh Panday',
    position: 'TechOps Coordinator',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:Neelansh,   
},
{
    name: 'Mr. Divyanshu Gupta',
    position: 'Events Coordinator',
    mail:'mailto:Divyanshu.20B0311189@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/divyanshu-gupta-691310202',
    instagram:'https://www.instagram.com/di_we_an_shu.2002',
    image:img11,
},
{
    name:'Mr. Shoaib ahmed',
    position:'Social Media Coordinator',
    mail:'mailto:shoaib.20b0211002@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/shoaib-ahmed-367916214',
    instagram:'https://instagram.com/shoaibahmed6433?igshid=Mzc0YWU1OWY=',
    image:img7,
},
{
    name:'Mr. Bhaskar Dev',
    position: 'Marketing And Coordinator',
    mail: 'mailto:bhaskar.21b0103011@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/bhaskar-dev-3718bb222',
     image:BhaskarDev,	
 },
 {
    name:'Ms. Anshika Singh' ,
    position:'Filmography Coordinator' ,
    mail:'mailto:Anshika.20b0311068@abes.ac.in' ,
    linkedIn:'https://www.linkedin.com/in/anshika-singh-0a7993220'	,
     instagram: 'annxiieee' ,
    image:img8,
},
                			
]


export const alumni = [
    {
    name:'Mr. Sarvesh Gautam',
    position: 'Founder E-Cell ABESEC/Founder of HAPPYPOT GARDEN PVT. LTD.',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:SarveshGautam,   
},
    {
    name:'Mr. Prabhansh Tripathi',
    position: 'Executive mentor & Former President E-Cell ABESEC/Dev at Accenture',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:PrabhanshTripathi,   
},
    {
    name:'Ms. Anuroopa Goswami',
    position: 'former Finance Mentor E-Cell ABESEC',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:AnuroopaGoswami,   
},
    {
    name:'Mr. Aditya Kumar',
    position: 'Photography Mentor E-Cell ABESEC',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:AdityaKumar,   
},
    {
    name:'Mr. Naman Kumar',
    position: 'TechOps Mentor E-Cell ABESEC',
    mail:'mailto:Neelansh.20B0131095@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/neelansh-pandey-81348b21b',
    image:NamanKumar,   
}
]


export const team=[
    
    {
        name:'SAURABH SRIVASTAVA'	,
        position: 'Technical Department',
        mail: 'mailto:Saurabh.20B0131057@abes.in',		
        linkedIn:'https://www.linkedin.com/in/saurabh-srivastava-714818202',
        instagram:'https://instagram.com/saurabh.js_?igshid=Mzc0YWU1OWY=',	
        image:img5,	
},
{
    name:'Shivang Singh Rawat',
    position:'Technical Department' ,
   mail:  'mailto:shivang.20b0131079@abes.ac.in'	,
   linkedIn: 'http://www.linkedin.com/in/rawatshiv',	
    instagram:'www.instagram.com/rawat_shivx28',	
   image: img4,
},
{
    name:'Shiwatvi',
    position:'Technical Department',
    mail:'mailto:shiwatvi.20b0211032@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/shiwatvi-dwivedi-0a12a1202',
    instagram:'https://www.instagram.com/grace_sur_moi/?next=%2F',
    image:img6,
},
{
    name:'Rudransh Jain',
    position:'Events And Planning Department',
    mail:'mailto:rudransh.20b0131193@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/rudransh-jain-113522221/',
    image:RudranshJain,
},
{
    name:'Shashank Shekhar Yadav',
    position: 'Events and Planning Department',
    mail: 'mailto:shashankshekhar26yadav@gmail.com',
    linkedIn:'https://www.linkedin.com/in/shashank-shekhar-yadav-a088b81ba',
     instagram:'https://instagram.com/shashankshekharyad?igshid=Mzc0YWU1OWY=',	
    image:img3,	
 },

 {
    name:'Shubhansh Mahawar',
    position:'Social Media Department',
    mail:'mailto:shubhansh.20b0311114@abes.ac.in',
    linkedIn:'https://www.linkedin.com/in/shubhansh-mahawar-5a822420b',
    image:ShubhanshMahawar,
},

{
    name:'Shreyash Panday',
    position:'Documentation And Policies Department',
    mail:  'mailto:Shreyash.20b1531113@abes.ac.in',
    linkedIn: 'https://www.linkedin.com/in/shreyash-pandey-7064ab202',
    image:ShreyashPandey,
},
{
    name:'Abhay Bansal',
    position:'Core LinkedIn team',
    mail:  'mailto:abhay.21b0131071@abes.ac.in',
    linkedIn: 'https://www.linkedin.com/in/abhay-bansal-4262b8224',
    image:AbhayBansal,
},


]


  export const members= [
      {
        name: "Saurabh Srivastava",
        year: "Fourth Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Shivang Rawat",
        year: "Fourth Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Shubhansh Mahawar",
        year: "Fourth Year",
        department: "Digital Social Media"
      },
      {
        name: "Shashank Shekhar Yadav",
        year: "Fourth Year",
        department: "Events"
      },
      {
        name: "Rudransh Jain",
        year: "Fourth Year",
        department: "Events"
      },
      {
        name: "Anuj Mishra",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Parth Bhardwaj",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Keshav Singh",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Aadya Shree",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Ayush Mishra",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Sai Goswami",
        year: "Second Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Deepali Jain",
        year: "Second Year",
        department: "Digital Social Media"
      },
      {
        name: "Dewansh Tyagi",
        year: "Second Year",
        department: "Digital Social Media"
      },
      {
        name: "Tanishka Saharawat",
        year: "Second Year",
        department: "Digital Social Media"
      },
      {
        name: "Ishita Rathore",
        year: "Second Year",
        department: "Digital Social Media"
      },
      {
        name: "Agrima Ranjan",
        year: "Second Year",
        department: "Digital Social Media"
      },
      {
        name: "Tanishka Singh",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Saket Abhishek",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Hirdyanshu Gupta",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Isha Tripathi",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Anshika Mishra",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Vinit Baishkiyar",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Stuti Sharma",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Shreya Dubey",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Shubhi Sharma",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Unnati Malik",
        year: "Second Year",
        department: "Events"
      },
      {
        name: "Kanika Tayal",
        year: "Second Year",
        department: "Finance"
      },
      {
        name: "Sayed Haneef",
        year: "Second Year",
        department: "Finance"
      },
      {
        name: "Shubhangi Singh",
        year: "Second Year",
        department: "Finance"
      },
      {
        name: "sparsh sharma",
        year: "Second Year",
        department: "Finance"
      },
      {
        name: "Aman Sharma",
        year: "Second Year",
        department: "Finance"
      },
      {
        name: "Devansh Pathak",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Anisha Rawat",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Aakarshan Prakash",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Suyash Gupta",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Sona Poddar",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Ishan Garg",
        year: "Second Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Princy Pandey",
        year: "Second Year",
        department: "Visual Media"
      },
      {
        name: "Devansh Goel",
        year: "Second Year",
        department: "Visual Media"
      },
      {
        name: "Divyam Kumar",
        year: "Second Year",
        department: "Visual Media"
      },
      {
        name: "Devansh Dwivedi",
        year: "Second Year",
        department: "Visual Media"
      },
      {
        name: "Ayush Tomer",
        year: "Third Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Amal Kumar",
        year: "Third Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Abhay Thakur",
        year: "Third Year",
        department: "Digital Infrastructure"
      },
      {
        name: "Ruddra Shukla",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Priyanshu Maheshwari",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Rishabh Bajpai",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Dhruv Gangwani",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Al Saif Siddique",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Ayushman Kushwaha",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Abhishek Bana",
        year: "Third Year",
        department: "Digital Social Media"
      },
      {
        name: "Dhruv Sharma",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Ishita Gupta",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Dheer Chanana",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Akshita Singh",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Ayush Kumar Rai",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Aditya Pandey",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Jahnvi Bansal",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Anshika Chaudhary",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Nayyab",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Shubhang Tripathi",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Suvigya Srivastava",
        year: "Third Year",
        department: "Events"
      },
      {
        name: "Sarthak Gupta",
        year: "Third Year",
        department: "Finance"
      },
      {
        name: "Arindam Rajvardhan",
        year: "Third Year",
        department: "Finance"
      },
      {
        name: "Ziyaad Ali",
        year: "Third Year",
        department: "Finance"
      },
      {
        name: "Abhay Bansal",
        year: "Third Year",
        department: "Marketing And Outreach"
      },
      {
        name: "Zaid Usmani",
        year: "Third Year",
        department: "Visual Media"
      },
      {
        name: "Naman Zadoo",
        year: "Third Year",
        department: "Visual Media"
      },
      {
        name: "Yash Kumar Mittal",
        year: "Third Year",
        department: "Visual Media"
      },
      {
        name: "Govind Sangal",
        year: "Third Year",
        department: "Visual Media"
      },
      {
        name: "Shikhar Shaurya",
        year: "Third Year",
        department: "Visual Media"
      }
    ]
  
  
            
    
            
            
	        
            
	        
            
            
	        
            
            
            
    	    
          
          
          
          	
          
			
            
	        
    	    
            
            
          